export default "__VITE_ASSET__DtdWSZ9m__"